<template>
    <div class="gz-input-container">
        <Label 
            :label="label" 
            :labelClickable="labelClickable" 
            :required="required"
            @labelClick="$emit('label-click')"
            :note="note"
        />

        <div class="gz-input__slot-container">
            <!-- Text Input -->
            <slot></slot>
            <!-- End Text Input -->
            <div v-if="action" @click.stop="$emit('icon-click')" class="gz-input__control-icon">
                <span class="icon-bin"></span>
            </div>
        </div>
        
        <ValidationMark 
            v-if="type !== 'filter'" 
            :valid="valid" 
            :validationMessage="validationMessage"
        />        
    </div>
</template>

<script>
import Label from './Label'
import ValidationMark from './BaseValidationMark'

export default {
    name: 'InputContainer',

    props: {
        type: {
            //Фильтр или форма
            type: String,
            default: 'form'
        },
        label: {
            type: String
        },
        labelClickable: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        valid: {
            type: Boolean,
            default: true
        },
        validationMessage: {
            type: String,
            default: 'Обязательно для заполнения'
        },
        action: {
            type: Boolean,
            default: false
        },
        note: String
    },
    components: {
        ValidationMark,
        Label
    }
}
</script>